export default class PdfModel {
  constructor(private data: string) {}

  getPdfUrl(openInApp: boolean) {
    const byteCharacters = atob(this.data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    if (openInApp) {
      if (import.meta.env.DEV) console.log("Opening PDF in app");
      return "data:application/pdf;base64," + this.data;
    } else {
      if (import.meta.env.DEV) console.log("Opening PDF in new tab");
      return url;
    }
  }

  openPdf(openInApp: boolean) {
    const url = this.getPdfUrl(openInApp);
    if (openInApp) {
      (globalThis as unknown as any).ReactNativeWebView.postMessage(url);
    } else {
      globalThis.open(url, "_blank");
    }
  }
}
